import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { JustMakingSureModalPage } from '../just-making-sure-modal/just-making-sure-modal.page';
import { Router } from '@angular/router';

@Component({
  selector: 'app-action-needed-modal',
  templateUrl: './action-needed-modal.page.html',
  styleUrls: ['./action-needed-modal.page.scss'],
})
export class ActionNeededModalPage implements OnInit {
  
  @Input() contactMethod: string;
  @Input() contactValue: string;
  decryptedData: any;
  
  get isEmail(): boolean {
    return this.contactMethod?.toLowerCase() === 'email';
  }
  
  get contactTypeLabel(): string {
    return this.isEmail ? 'email address' : 'phone number';
  }
  

  constructor(
      private modalController: ModalController,
      private router: Router
    ) { }

  ngOnInit() {
    // Get the entire decrypted object from localStorage
    const storedData = localStorage.getItem('deeplinkDecryptedData');
    if (storedData) {
      this.decryptedData = JSON.parse(storedData);
      console.log(this.decryptedData, "this.decryptedData this.decryptedData this.decryptedData");
      // Use stored values if props not passed
      if (!this.contactMethod) {
        this.contactMethod = this.decryptedData.method;
      }
      if (!this.contactValue) {
        this.contactValue = this.decryptedData.contactValue;
      }
    }

    console.log('Decrypted Data:', this.decryptedData);
    console.log(this.contactMethod, this.contactValue, "contactMethod contactMethod contactMethod");
  }

  async no() {
    await this.modalController.dismiss('no');
    
    // Get stored decrypted data
    const storedData = localStorage.getItem('deeplinkDecryptedData');
    const decryptedData = storedData ? JSON.parse(storedData) : null;
    
    const modal = await this.modalController.create({
      component: JustMakingSureModalPage,
      cssClass: 'modal_all',
      backdropDismiss: false,
      componentProps: {
        contactMethod: this.contactMethod || decryptedData?.method,
        contactValue: this.contactValue || decryptedData?.contactValue
      }
    });
    await modal.present();
  }
  yes() {
    // First, get the contact method and value (use component properties or fallback to localStorage)
    const storedData = localStorage.getItem('deeplinkDecryptedData');
    const decryptedData = storedData ? JSON.parse(storedData) : null;
    
    const contactMethod = this.contactMethod || decryptedData?.method;
    const contactValue = this.contactValue || decryptedData?.contactValue;
    
    // Dismiss modal first
    this.modalController.dismiss('yes');
    
    // Navigate to signup-punchlist-email with query params
    setTimeout(() => {
      this.router.navigate(['/signup-punchlist-email'], {
        queryParams: {
          autoConnect: 'true',
          contactMethod: contactMethod,
          contactValue: contactValue
        }
      });
    }, 300);
  }

  goBack() {
    // Clean up stored data when modal is dismissed
    localStorage.removeItem('deeplinkDecryptedData');
    localStorage.removeItem('emailFromLogin');
    localStorage.removeItem('mobileFromLogin');
    this.modalController.dismiss();
  }

}

